var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.592,
    height: 27.592,
    viewBox: "0 0 27.592 27.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#212548;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M13.85,0A13.85,13.85,0,0,0,0,13.742a13.942,13.942,0,0,0,13.85,13.85A13.8,13.8,0,0,0,13.85,0Zm1.617,21.125a1.617,1.617,0,0,1-3.233,0V12.934a1.617,1.617,0,1,1,3.233,0ZM13.85,8.084a1.617,1.617,0,1,1,1.617-1.617A1.619,1.619,0,0,1,13.85,8.084Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.c7c89c13a25f089bf3f071174fe7e131.svg";
export { ForwardRef as ReactComponent };